export var HelpCenterPage;
(function (HelpCenterPage) {
  HelpCenterPage["faq"] = "faq";
  HelpCenterPage["sign"] = "sign";
  HelpCenterPage["contact"] = "contact";
})(HelpCenterPage || (HelpCenterPage = {}));